<div [ngClass]="classes">
  <ng-content></ng-content>
</div>
